
<br>
<div class="filtro justify-between border border-solid rounded border-gray-300 dark:border-gray-500 p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center">
  <div class="grid grid-cols-3 gap-4" [formGroup]="reporteForm">
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Plaza de cobro</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="caseta">
        <option value="" disabled>Seleccione una caseta</option>
        <option *ngFor="let caseta of casetas" value="{{ caseta.id }}">{{ caseta.nombre}}</option>
      </select>
    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Fecha</div>
      <input type="date" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="fecha">
    </div>
     <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Reporte</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="tipo">
        <option value="" disabled>Seleccione un Tipo de Reporte</option>
        <option value="1">Diario</option>
        <option value="2">Mensual</option>
      </select>
    </div>
    <div class="grid grid-cols-2 gap-4 col-span-2">
      <button class="estilo-dark dark:text-gray-100 dark:bg-blue-600 " (click)="generarReporte()">Generar</button>
    </div>
    <div>
  </div>

</div>
